import type { AppState } from 'types/app';
import getCancelReturnItems from 'components/exchanges/utils/getCancelReturnItems';

export const selectOrder = (state: AppState) => state.order;

export const selectOrderLineItems = (state: AppState) => selectOrder(state)?.order?.lineItems;

export const selectCancelReturnItems = (state: AppState, itemIds: string[]) => getCancelReturnItems(selectOrderLineItems(state), itemIds);
